<template>
  <div>
    <Breadcrumbs main="" :title="$t('lbl_EMPBE_ProductInfoCenter')" />
    <!-- <div class="b-sidebar-backdrop bg-dark" style="z-index: 100" v-if="sidebarMenu" @click="handleSidebarHide"></div> -->
    <visitorPermission>
      <template v-slot:body>
        <div class="container-fluid">
          <div class="">
            <div class="row">
              <productListing v-if="showProductListing" ref="production" :hideSidebarNavMenu="hideSidebarNavMenu" ></productListing>
              <router-view ref="currentItem"></router-view>
              <!-- <b-sidebar :id="ProductStyleId" class="customSidebar" title="" right bg-variant="white" :shadow="true"
                :no-close-on-backdrop="true" :no-header-close="true" ref="productRightpopup" v-model="sidebarMenu">
                <router-view ref="currentItem"></router-view>
                <div class="d-flex" slot="header">
                  <button type="button" style="border: none; background-color: transparent" @click="handleSidebarHide">
                    <i class="icon-close f-14"></i>
                  </button>
                </div>
              </b-sidebar> -->
            </div>
          </div>
        </div>
      </template>
    </visitorPermission>
  </div>
</template>

<script>
import { computed } from "vue";
import { mapGetters } from "vuex";
import { userService } from "@/_services";
import productListing from "./productlisting.vue";
import { AlertDialog } from "@/_helpers/AlertDialog";
import { productService } from "@/_services/product.service";

export default {
  mixins: [AlertDialog],
  components: {
    productListing,
  },
  data() {
    return {
      sidebarVisible: false,
      permissionData: null,
      sidebarMenu: this.currentRouteName != "NewproductInfoCenterDefault",
      ProductStyleId: "productRightpopup",
      ParentClick:
      {
        state: false,
        CatalogueState:false
      },
      currentTab:0,
    };
  },
  created() {
    this.UpdateBackGroup();
    this.sidebarMenu = this.currentRouteName != "NewproductInfoCenterDefault";
  },
  mounted() {
    this.sidebarMenu = this.currentRouteName != "NewproductInfoCenterDefault";
  },
  computed: {
    ...mapGetters({
      getPermissionJsonByUser: "responsePermission/getPermissionJsonByUser",
    }),
    currentRouteName() {
      return this.$route.name;
    },
    user() {
      return this.$store.state.authentication.user;
    },
    companyid() {
      return this.user.empCompanyId;
    },
    showProductListing() {
      // 当路由是 default 时显示 productListing 组件
      return this.currentRouteName === "NewproductInfoCenterDefault";
    },
   
  },
  watch: {
    '$route'(to, from) {
      this.UpdateBackGroup();
    },
    currentRouteName: {
      handler() {
        this.sidebarMenu = this.currentRouteName != "NewproductInfoCenterDefault";
      },
    },
    sidebarMenu: {
      handler() {
        this.$nextTick(() => {
          this.sidebarMenu = this.currentRouteName != "NewproductInfoCenterDefault";
        });
      },
    },
  },
  mounted() {
    // 监听子组件的刷新事件
    this.$on("refresh", this.refresh);
  },
  provide() {
    return {
      permissionData: computed(() => this.permissionData),
      ChildSubmit: this.ParentClick
    };
  },
  // created(){
  //   this.GetSysCompanySponsorType();
  // },
  mounted() {
    this.GetSysCompanySponsorType();
  },
  methods: {
    UpdateBackGroup() {
      this.ProductStyleId = "productRightpopup";
      const routePath = this.$route.path;
      if (routePath.includes('indexDetail')) {
        this.ProductStyleId = 'productIndexRightpopup'
      }
    },
    SideBar() {
      return this.currentRouteName != "NewproductInfoCenterDefault";
    },
    handleSidebarHide() {

      if (this.$store.state.dirty) {
        const routePath = this.$route.path;
        if (routePath.includes('indexDetail')) {
          this.LeavePageMethodsAfterSave(
                this.$t('lbl_EMPBE_ProductInfo_PageLeaveSubmit_Title'),
                this.$t('lbl_EMPBE_ProductInfo_PageLeaveSubmit_Body'),
                this.$t('lbl_EMPBE_CompanyInfo_Submit'),
                'Catalogue'
              );
        } else {
          const routeId = this.$route.params.id;
          this.LeavePageMethodsBypProductDetail(routeId);
        }
      } else {
        this.$refs["productRightpopup"].hide();
        this.$router.replace("/productInfoCenter/default");
      }
    },
    LeavePageMethodsBypProductDetail(productId) {
      productService
        .GetProductInfoStatus({ companyId: this.companyid, ProductId: productId })
        .then((res) => {
          if (res.isSuccessful) {
            //上架
            if(res.data?.lastSubmitDate != '' &&  res.data?.isLaunch == 1)
            {
              this.LeavePageMethodsAfterSave(
                this.$t('lbl_EMPBE_ProductInfo_PageLeaveSubmit_Title'),
                this.$t('lbl_EMPBE_ProductInfo_PageLeaveSubmit_Body'),
                this.$t('lbl_EMPBE_CompanyInfo_Submit'),
                'product'
              );
            }else 
            {
              this.LeavePageMethodsAfterSave(
                this.$t('lbl_EMPBE_ProductInfo_PageLeaveSave_Title'),
                this.$t('lbl_EMPBE_ProductInfo_PageLeaveSave_Body'),
                this.$t('lbl_EMPBE_CompanyInfo_Save'),
                'product'
              );
            }
          }else
          {
            this.LeavePageMethodsAfterSave(
                this.$t('lbl_EMPBE_ProductInfo_PageLeaveSave_Title'),
                this.$t('lbl_EMPBE_ProductInfo_PageLeaveSave_Body'),
                this.$t('lbl_EMPBE_CompanyInfo_Save'),
                'product'
              );
          }
        }).catch(() => {
        })
    },
    LeavePageMethods() {
      this.showLeavePage().then((result) => {
        if (result.isConfirmed) {
          //this.$refs.currentItem.refresh();
          this.$refs["productRightpopup"].hide();
          this.$router.replace("/productInfoCenter/default");
        }
      });
    },
    async LeavePageMethodsAfterSave(title,text,btnName,type) {
      this.ParentClick.state = false;
      this.ParentClick.CatalogueState = false;
      await this.showLeavePageAfterSave(
                title,
                text,
                btnName
      ).then((result) => {
        if (result.isDenied) {
          this.$refs["productRightpopup"].hide();
          this.$router.replace("/productInfoCenter/default");
        } else if (result.isConfirmed) {
          if(type=="product")
            this.ParentClick.state = true;
          else
            this.ParentClick.CatalogueState = true;
        }
      });
      // console.log("当前状态", this.ParentClick)
    },
    onBackdropClick() { },
    hideSidebarNavMenu() {
      this.$refs["productRightpopup"].hide();
      this.$router.replace("/productInfoCenter/default");
      // this.sidebarMenu = false;
    },
    //刷新
    refresh() {
      // console.log("刷新父组件");
      this.GetSysCompanySponsorType();
      this.$refs.production.fetchData();
    },
    getotherInfo() {
      return this.$refs.production.otherInfo;
    },
    openSidebarAfterSave() {
      this.$root.$emit("bv::toggle::collapse", "productRightpopup");
    },
    GetSysCompanySponsorType() {
      var that = this;
      // console.log(this.companyid);
      if (this.companyid > 0) {
        userService
          .GetSysCompanySponsorType({ CompanyId: this.companyid })
          .then((res) => {
            if (res.isSuccessful) {
              var data = res.data;
              that.permissionData = this.getPermissionJsonByUser({ user: data });
            }
          });
      }
    },
  },
 
};
</script>
<style>
h5 {
  font-weight: bold;
}

.tabbed .nav {
  position: absolute;
  left: 22px;
  top: 33px;
  border-bottom: none;
}

.nav-pills .nav-link {
  font-size: 16px;
}
</style>

<style>
#productRightpopup {
  background: var(--Background, #F2F3F5) !important;
}

#productRightpopup .b-sidebar-header {
  top: 10px !important;
}

#productIndexRightpopup .b-sidebar-header {
  top: 10px !important;
}

#productRightpopup .floatedLabel {
  left: 12px;

}
</style>